/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_StorylineInputs */



/**
* | output |
* | --- |
* | "Storyline decks are not archived" |
*
* @param {Twda_Reason_StorylineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_storyline = /** @type {((inputs?: Twda_Reason_StorylineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_StorylineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("les decks Storyline ne sont pas archivés")
	if (locale === "es") return /** @type {LocalizedString} */ ("los mazos Storyline no se archivan")
	if (locale === "pt") return /** @type {LocalizedString} */ ("decks Storyline não são arquivados")
	if (locale === "it") return /** @type {LocalizedString} */ ("i mazzi Storyline non vengono archiviati")
	return /** @type {LocalizedString} */ ("Storyline decks are not archived")
});